export {}

const baseHeaders = document.querySelectorAll<HTMLElement>(".base-header")
baseHeaders.forEach(baseHeader => {

  if (baseHeader.classList.contains("--perex-clamp")) {
    const perex = baseHeader.querySelector<HTMLElement>(".base-header__paragraph")
    const readMore = baseHeader.querySelector<HTMLElement>(".base-header__read-more")
    if (!perex || !readMore) return
    if (perex.scrollHeight > perex.clientHeight) {
      readMore.classList.add("--visible")
    }

    readMore.addEventListener("click", (e) => {
      e.preventDefault()
      baseHeader.classList.toggle("--open")
      const title = readMore.querySelector<HTMLElement>(".link__title")
      const alternativeTitle = readMore.dataset.alternativeText
      if (!title || !alternativeTitle) return

      const tempTitle = alternativeTitle
      readMore.dataset.alternativeText = title.innerHTML
      title.innerHTML = tempTitle
    })
  }
})
